import React from 'react'
import { useTranslation } from "next-i18next";
import Head from 'next/head';
import Layout from '@/components/shared/Layout'
import OurGoals from '@/components/about-us/OurGoals'
import Partners from '@/components/shared/Partners'
import ScrollAnimation from '@/components/shared/ScrollAnimation'
import OurMission from '@/components/about-us/OurMission'
import OurAchievement from '@/components/about-us/OurAchievement'
import WhyUs from '@/components/about-us/WhyUs'
import { META_IMAGE, SITE_URL } from "@/utils/meta";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ScrollToTopButton from '@/components/shared/ScrollToTopButton'
import WhatsappButton from '@/components/shared/WhatsappButton'

export async function getServerSideProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale || "az")),
        },
    };
}



const AboutUsPage = () => {
    const { t, i18n } = useTranslation();
    const pageUrl = `${SITE_URL}${i18n.language === "az" ? "" : `/${i18n.language}`}/about-us`;
    return (
        <>
            <Head>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>{t("about-us-page.meta-title")}</title>
                <meta name="keywords" content={t("about-us-page.meta-keywords")} />
                <meta name="description" content={t("about-us-page.meta-description")} />
                <meta name="image" content={META_IMAGE} />
                <link rel="canonical" href={pageUrl} />
                <meta property="og:site_name" content="peerstack.tech" />
                <meta property="og:title" content={t("about-us-page.meta-title")} />
                <meta property="og:url" content={pageUrl} />
                <meta property="og:description" content={t("about-us-page.meta-description")} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={META_IMAGE} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t("about-us-page.meta-title")} />
                <meta name="twitter:url" content={pageUrl} />
                <meta name="twitter:description" content={t("about-us-page.meta-description")} />
                <meta name="twitter:image" content={META_IMAGE} />
                {/*<script*/}
                {/*  type="application/ld+json"*/}
                {/*  dangerouslySetInnerHTML={{*/}
                {/*    __html: JSON.stringify({*/}
                {/*      "@context": "https://schema.org",*/}
                {/*      "@type": "Organization",*/}
                {/*      name: "PeerStack",*/}
                {/*      alternateName: "PeerStack Tech",*/}
                {/*      url: "https://peerstack.tech",*/}
                {/*      logo: Logo.src,*/}
                {/*      contactPoint: {*/}
                {/*        "@type": "ContactPoint",*/}
                {/*        telephone: "50 999 88 77",*/}
                {/*        contactType: "customer service",*/}
                {/*        areaServed: "AZ",*/}
                {/*        availableLanguage: "Azerbaijani",*/}
                {/*      },*/}
                {/*      sameAs: ["https://peerstack.tech/", "https://peerstack.tech/"],*/}
                {/*    }),*/}
                {/*  }}*/}
                {/*/>*/}
            </Head>
            <Layout>
                <ScrollAnimation delay={100}>
                    <OurGoals />
                </ScrollAnimation>
                <ScrollAnimation delay={100}>
                    <OurMission />
                </ScrollAnimation>
                <ScrollAnimation delay={100}>
                    <OurAchievement />
                </ScrollAnimation>
                <ScrollAnimation delay={100}>
                    <WhyUs />
                </ScrollAnimation>
                <ScrollAnimation delay={100} className='overflow-hidden'>
                    <Partners />
                </ScrollAnimation>
                <ScrollToTopButton />
                <WhatsappButton />
            </Layout>
        </>
    )
}

export default AboutUsPage
